import { render, staticRenderFns } from "./CreateOtherSupplierOrderPopUp.vue?vue&type=template&id=cff82ec4&scoped=true&"
import script from "./CreateOtherSupplierOrderPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateOtherSupplierOrderPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateOtherSupplierOrderPopUp.vue?vue&type=style&index=0&id=cff82ec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff82ec4",
  null
  
)

export default component.exports